import React from "react";
import { RotaRadio } from "@teamrota/rota-design";
import { RadioGroup } from "./style";

const HOUR_RANGES = ["0-12", "12-24", "24-36", "36+"];

const WeeklyHours = ({ selectedHours, onHoursChange }) => {
  return (
    <RadioGroup>
      {HOUR_RANGES.map(range => (
        <RotaRadio
          key={range}
          label={range}
          value={range}
          checked={selectedHours === range}
          onChange={() => onHoursChange(range)}
        />
      ))}
    </RadioGroup>
  );
};

export default WeeklyHours;
